<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
};
</script>

<style lang="scss">
html,
body,
#app {
  margin: 0;
  padding: 0;
  font-size: 16px;
  height: 100%;
  font-family: "微软雅黑", serif;
  background: #f5f3f3;
}

input,
button {
  outline: none;
}

.nav {
  height: 40px;
  line-height: 40px;
  background: #f5f3f3;
  display: flex;
  align-items: center;

  .back {
    width: 20px;
    height: 20px;
  }

  .title {
    flex: 1;
    font-size: 20px;
    text-align: center;
  }
}

</style>
